export const getDefaultMapWidgetLayout = (payload, index = 0) => {
  const type = payload?.type;
  const width =
    type === 'divider'
      ? 320
      : type === 'pics'
        ? 220
        : type === 'timeline'
          ? 360
          : 320;
  const height =
    type === 'divider'
      ? 24
      : type === 'pics'
        ? 180
        : type === 'text'
          ? 140
          : type === 'timeline'
            ? 220
            : 120;
  return {
    x: 48 + (index % 3) * 360,
    y: 48 + Math.floor(index / 3) * 180,
    w: width,
    h: height,
  };
};
